import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "nebula",
      component: () => import("@/views/CityNebulaView.vue")
    },
    {
      // 这是一个可分享、可重复打开的欢迎引导入口；实际内容由 App 顶层引导层呈现。
      path: "/welcome",
      name: "welcome",
      component: () => import("@/views/CityNebulaView.vue")
    },
    {
      path: "/map",
      name: "map",
      component: () => import("@/views/HeritageMapView.vue")
    },
    {
      path: "/crowdsource",
      name: "crowdsource",
      component: () => import("@/views/CrowdSourceHome.vue")
    },
    {
      path: "/crowdsource/submit",
      name: "crowdsource-submit",
      component: () => import("@/views/CrowdSourceSubmitView.vue")
    },
    {
      path: "/crowdsource/list",
      name: "contribution-browse",
      component: () => import("@/views/ContributionBrowseView.vue")
    },
    {
      path: "/crowdsource/map",
      name: "crowd-map",
      component: () => import("@/views/CrowdMapView.vue")
    },
    {
      path: "/crowdsource/archive",
      redirect: { name: "crowdsource-submit", query: { type: "BUILDING_INFO" } }
    },
    {
      path: "/admin/archive-review",
      name: "archive-review",
      component: () => import("@/views/ArchiveReviewView.vue")
    },
    {
      path: "/admin/archive-topics",
      name: "archive-topic-workbench",
      component: () => import("@/views/ArchiveTopicWorkbenchView.vue")
    },
    {
      path: "/crowdsource/detail/:id",
      name: "contribution-detail",
      component: () => import("@/views/ContributionDetailView.vue"),
      props: true
    },
    {
      path: "/growth",
      name: "growth",
      component: () => import("@/views/UrbanGrowthView.vue")
    },
    {
      path: "/growth/s3m-test",
      name: "growth-s3m-test",
      component: () => import("@/views/UrbanGrowthS3MTestView.vue")
    },
    {
      path: "/buildings/:buildingId",
      name: "building-detail",
      component: () => import("@/views/BuildingDetailView.vue"),
      props: true
    },
    {
      path: "/photos",
      name: "old-photos",
      component: () => import("@/views/OldPhotoHomeView.vue")
    },
    {
      path: "/photos/comparisons",
      name: "photo-comparisons",
      redirect: { name: "photo-archive", query: { view: "compare" } }
    },
    {
      path: "/photos/recognize",
      name: "photo-recognition",
      redirect: { name: "photo-workbench" }
    },
    {
      path: "/photos/archive",
      name: "photo-archive",
      component: () => import("@/views/PhotoArchiveSystemView.vue")
    },
    {
      path: "/photos/locate",
      name: "photo-workbench",
      component: () => import("@/views/PhotoWorkbenchView.vue")
    },
    {
      path: "/photos/my-images",
      name: "my-images",
      component: () => import("@/views/MyImagesView.vue")
    },
    {
      path: "/photos/located",
      name: "photo-located",
      redirect: (to) => ({
        name: "photo-archive",
        query: {
          ...to.query,
          view: "located"
        }
      })
    },
    {
      path: "/photos/workbench",
      redirect: { name: "photo-workbench" }
    },
    {
      path: "/admin/photo-alignment",
      name: "photo-alignment-admin",
      component: () => import("@/views/PhotoAlignmentAdminView.vue")
    },
    {
      path: "/admin/photo-pose-annotation",
      name: "photo-pose-annotation",
      component: () => import("@/views/PhotoPoseAnnotationView.vue")
    },
    {
      path: "/memory-grid/:level/:gridId",
      name: "memory-grid-insight",
      component: () => import("@/views/MemoryGridInsightView.vue"),
      props: true
    },
    {
      path: "/spatial-stats",
      name: "spatial-stats",
      component: () => import("@/views/SpatialStatsView.vue")
    },
    {
      path: "/buildings/:buildingId/reposition",
      name: "building-reposition",
      redirect: (to) => ({
        name: "photo-archive",
        query: {
          view: "located",
          stage: "verify",
          buildingId: String(to.params.buildingId)
        }
      })
    },
    {
      path: "/photos/:mediaId/reposition",
      name: "photo-reposition",
      redirect: (to) => ({
        name: "photo-archive",
        query: {
          view: "located",
          stage: "verify",
          photoId: String(to.params.mediaId)
        }
      })
    }
  ],
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 92 };
    }
    return { top: 0 };
  }
});

export default router;
